export default __webpack_public_path__ + "static/cardImg2-f8598ec9f7e8873c53ea0133fea00360.webp";